import {Component, OnInit} from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { version } from '../../../../../environments/version';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'qm-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  public loggedIn: boolean = false;
  public version: { version: string, date: string };

  /**
   * Inits the view.
   * @param auth
   */
  constructor(public auth: AuthService) {
    this.version = {
      version,
      // TODO: do something else?
      date: undefined
    };
  }

  /**
   * Inits loggdIn parameter.
   */
  async ngOnInit() {
    this.loggedIn = this.auth.getStatus() === 'logged_in';
  }

  /**
   * Is production version in use.
   */
  public isProduction(): boolean {
    return environment.production;
  }
}
